import {
  Box,
  Container,
  Heading,
  Breadcrumb,
  BreadcrumbItem,
  Text,
  HStack,
  Stack,
  Badge,
  FormControl,
  VStack,
  CircularProgress,
} from "@chakra-ui/react";

import {
  Pagination,
  PaginationContainer,
  PaginationNext,
  PaginationPage,
  PaginationPageGroup,
  PaginationPrevious,
  PaginationSeparator,
  usePagination,
} from "@ajna/pagination";

import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import { CgDatabase } from "react-icons/cg";

//Components
import Header from "components/dashHeader";
import Sidemenu from "components/sidemenu";
import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";

import { useParams, useHistory } from "react-router-dom";
// import WalletTransfer from "components/WalletTransfer/WalletTransfer";
import { useCallback, useMemo, useState } from "react";
import Button from "components/Button/Button";
// import { NumberInputWithMax } from "components/Input/NumberInput";
// import toPrecision from "util/toPrecision";

import { ReactComponent as AddCircleIcon } from "assets/svg/add-circle.svg";
import toCoinLocale from "util/toCoinLocale";
import StakeInfo from "components/StakeInfo/StakeInfo";
import toPrecision from "util/toPrecision";
import Select from "components/Select/Select";
import { useGetEarnWalletQuery, useGetStakingsQuery } from "services/walletApi";
import { toQueryString } from "util/utils";
// import uniq from "lodash/uniq";
import capitalize from "lodash/capitalize";
import { clamp, toLower } from "lodash";
import StakedAmount from "components/StakedAmount/StakedAmount";

export default function CoinEarnings(props) {
  const currentPage = "Earn";

  const { coin } = useParams();
  const history = useHistory();

  const [filter, setFilter] = useState("all");

  const [queries, setQueries] = useState({
    unit: coin,
    status: filter === "all" ? null : filter,
    actionType: "staking_in,staking_out",
    latestChain: "true",
    // actionType: "staking_in",
  });

  const { data, isLoading, isFetching } = useGetStakingsQuery(
    toQueryString(queries)
  );

  const { data: earnData /*isLoading: isLoadingWallets*/ } =
    useGetEarnWalletQuery();

  const wallets = useMemo(() => earnData?.wallets, [earnData]);
  const selectedWallet = useMemo(
    () => coin && wallets?.find((w) => w?.unit === coin),
    [coin, wallets]
  );

  const earnings = useMemo(() => data?.records, [data]);
  const totalCount = useMemo(() => data?.totalCount, [data]);
  const coinEarnings = useMemo(
    () => earnings?.filter((earn) => earn?.unit === coin),
    [earnings, coin]
  );

  const {
    pages,
    pagesCount,
    offset,
    currentPage: page,
    setCurrentPage,
    isDisabled,
    pageSize,
  } = usePagination({
    total: totalCount,
    limits: {
      outer: 1,
      inner: 1,
    },
    initialState: {
      pageSize: 10,
      isDisabled: false,
      currentPage: 1,
    },
  });

  // const filteredEarnings = useMemo(
  //   () =>
  //     coinEarnings?.filter((e) =>
  //       filter === "all" ? e : e?.status === filter
  //     ),
  //   [coinEarnings, filter]
  // );

  // const filterOptions = useMemo(
  //   () => uniq(["all", ...(coinEarnings ?? [])?.map((earn) => earn?.status)]),
  //   [coinEarnings]
  // );

  console.log("Earnings", coinEarnings);

  const handlePageChange = (nextPage) => {
    setCurrentPage(nextPage);
    setQueries((queries) => ({ ...queries, page: nextPage, limit: 10 }));
  };

  const handleFilter = (e) => {
    e.preventDefault();
    const value = e.target.value;
    setFilter(value);
    // if (value === "all") return;

    setQueries((queries) => {
      if (value === "all")
        return { ...queries, status: null, currentStatus: null };
      if (value === "active") return { ...queries, currentStatus: value };
      return { ...queries, status: value, currentStatus: null };
    });
  };

  const badgeStyles = useCallback((status) => {
    const map = {
      active: {
        bg: "#F4B7401f",
        color: "#F4B740",
      },
      rolledover: {
        bg: "#F4B7401f",
        color: "#F4B740",
      },
      redeemed: {
        bg: "#CEEEE1",
        color: "var(--primary)",
      },
      terminated: {
        bg: "#eecece",
        color: "#bb0404",
      },
    };

    return map[status ?? "active"];
  }, []);

  //   const [state, _set] = useState({
  //     coin,
  //     from: params.get("from") ?? "earn",
  //     to: params.get("to") ?? "main",
  //   });

  //   const set = useCallback(
  //     (update) => _set((old) => ({ ...old, ...update })),
  //     []
  //   );

  // console.log("Transfer", state);

  //   const isDisabled = useMemo(
  //     () => !(state?.coin && state?.from && state?.to && state?.amount),
  //     [state]
  //   );

  return (
    <Box>
      <Sidemenu currentPage={currentPage} logoutUser={props.logout} />
      <Header />

      <Box className="cards">
        <Box
          className="page-container"
          p={["6em 0 !important", "6.5em 1.5em !important"]}
        >
          <Container
            maxW={["100%", "100%", "calc(100% - 30vw)", "calc(100% - 45vw)"]}
            m="0"
            // p="0"
          >
            <Box px={["0", "0", "0"]}>
              <Heading fontSize="3xl">
                All {toCoinLocale(coin)} Earnings
              </Heading>

              <Breadcrumb separator={<ChevronRightIcon color="gray.500" />}>
                {/* <BreadcrumbItem>
                  <BreadcrumbLink to={`/dashboard/wallet`}>
                    Wallet
                  </BreadcrumbLink>
                </BreadcrumbItem> */}

                <BreadcrumbItem>
                  <BreadcrumbLink to={`/dashboard/earn/staking?coin=${coin}`}>
                    Earn
                  </BreadcrumbLink>
                </BreadcrumbItem>

                {/* <BreadcrumbItem>
                  <BreadcrumbLink to={`/dashboard/earn/earnings/${coin}`}>
                    Earnings
                  </BreadcrumbLink>
                </BreadcrumbItem> */}

                <BreadcrumbItem isCurrentPage>
                  <BreadcrumbLink isCurrentPage href="#">
                    {toCoinLocale(coin)} Earnings
                  </BreadcrumbLink>
                </BreadcrumbItem>
              </Breadcrumb>
            </Box>

            <HStack justifyContent="flex-end" mb="18px">
              <Button
                // disabled={!isEligible}
                variant="ghost"
                bg="transparent"
                size="sm"
                color="#03A438"
                onClick={() => {
                  history.push(`/dashboard/earn/subscribe?coin=${coin}`);
                }}
              >
                <HStack>
                  <Box as={AddCircleIcon} />
                  <Text>Subscribe</Text>
                </HStack>
              </Button>
            </HStack>

            <Box
              bg="white"
              mt="20px"
              p={["24px", "56px"]}
              borderRadius={[0, "16px"]}
              border="1px solid #EFF0F7"
              pos="relative"
            >
              <StakedAmount
                variant="stake"
                amount={selectedWallet?.amountAtStake?.volume}
                coin={coin}
              />

              <FormControl mb="26px">
                <Text
                  as="label"
                  d="inline-block"
                  fontSize="14px"
                  color="#14142B"
                  mb="8px"
                >
                  Filter By
                </Text>
                <Select
                  placeholder="Select"
                  borderRadius="100px"
                  border="1px solid #EFF0F6 !important"
                  h="40px"
                  bg="white"
                  value={filter}
                  onChange={handleFilter}
                >
                  {["all", "active", "redeemed", "terminated"].map((filter) => (
                    <option
                      key={`filter-options-${filter}`}
                      value={toLower(filter)}
                    >
                      {capitalize(filter)}
                    </option>
                  ))}
                </Select>
              </FormControl>
              <Stack>
                {(coinEarnings ?? [])?.length < 1 && !isLoading && (
                  <VStack py="32px">
                    <Box as={CgDatabase} fontSize="48px" color="grey" />
                    <Text color="grey">No Data</Text>
                  </VStack>
                )}

                {isLoading && (
                  <VStack py="24px">
                    <CircularProgress
                      ml="20px !important"
                      isIndeterminate
                      color="var(--primary)"
                      size="20px"
                    />
                  </VStack>
                )}

                {!isLoading && isFetching && (
                  <VStack pos="absolute" right="20px" top="20px">
                    <CircularProgress
                      ml="20px !important"
                      isIndeterminate
                      color="var(--primary)"
                      size="14px"
                    />
                  </VStack>
                )}

                {(coinEarnings ?? [])?.map((stake) => (
                  <StakeInfo
                    coin={stake?.unit}
                    title={toPrecision(
                      stake?.value?.$numberDecimal,
                      stake.unit
                    )}
                    subtitle={
                      stake?.product?.tenor
                        ? `${stake?.product?.tenor} day${
                            stake?.product?.tenor > 1 ? "s" : ""
                          }`
                        : undefined
                    }
                    _child={{ top: "20px", right: "60px" }}
                    onClick={() => {
                      history.push(
                        `/dashboard/earn/earnings/${stake?.unit}/${stake?._id}`
                      );
                    }}
                  >
                    <Badge
                      p="4px 10px"
                      borderRadius="16px"
                      bg="#CEEEE1"
                      color="var(--primary)"
                      textTransform="capitalize"
                      fontWeight="500"
                      {...badgeStyles(stake.status)}
                    >
                      {stake.status}
                    </Badge>
                  </StakeInfo>
                ))}
              </Stack>

              {!isLoading && coinEarnings?.length > 0 && (
                <Box className="paginate-box" mt="2em !important">
                  <HStack
                    bg="white"
                    // p="10px 40px"
                    justifyContent="space-between"
                    borderRadius="0px 0px 16px 16px"
                    flexDir={["column", "row"]}
                    w="100%"
                    mt="0 !important"
                  >
                    <Text>
                      Showing {offset + 1} to{" "}
                      {clamp(
                        offset + pageSize,
                        Math.min(totalCount, pageSize),
                        totalCount ?? 0
                      )}{" "}
                      of {totalCount ?? 0}
                    </Text>
                    <HStack>
                      <Pagination
                        pagesCount={pagesCount}
                        currentPage={page}
                        isDisabled={isDisabled}
                        onPageChange={handlePageChange}
                      >
                        <PaginationContainer
                          align="center"
                          justify="space-between"
                          p={4}
                          w="full"
                        >
                          <PaginationPrevious
                            mr="8px"
                            boxSize="32px"
                            _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
                            _active={{ bg: "transparent" }}
                            _hover={{
                              bg: "transparent",
                            }}
                            bg="transparent"
                          >
                            <ChevronLeftIcon />
                          </PaginationPrevious>
                          <PaginationPageGroup
                            isInline
                            align="center"
                            separator={
                              <PaginationSeparator
                                border="1px solid #DFE3E8"
                                bg="transparent"
                                fontSize="sm"
                                boxSize="32px"
                                jumpSize={4}
                                _active={{ bg: "transparent" }}
                                _hover={{
                                  bg: "transparent",
                                }}
                                _focus={{
                                  borderColor: "transparent",
                                  shadow: "0 0 0 3px var(--focusColor)",
                                }}
                              />
                            }
                          >
                            {pages.map((page) => (
                              <PaginationPage
                                boxSize="32px"
                                bg="transparent"
                                border="1px solid #DFE3E8"
                                key={`pagination_page_${
                                  page || Math.random() * 7676767665453
                                }`}
                                page={page}
                                fontSize="sm"
                                _active={{ bg: "transparent" }}
                                _hover={{
                                  bg: "transparent",
                                }}
                                _focus={{
                                  borderColor: "transparent",
                                  shadow: "0 0 0 3px var(--focusColor)",
                                }}
                                _current={{
                                  borderColor: "transparent",
                                  bg: "#03a438",
                                  fontSize: "sm",
                                  boxSize: "32px",
                                  color: "white",
                                  _hover: {
                                    borderColor: "#DFE3E8",
                                    bg: "transparent",
                                    color: "black",
                                  },
                                }}
                              />
                            ))}
                          </PaginationPageGroup>
                          <PaginationNext
                            ml="8px"
                            boxSize="32px"
                            _active={{ bg: "transparent" }}
                            _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
                            _hover={{
                              bg: "transparent",
                            }}
                            bg="transparent"
                          >
                            <ChevronRightIcon />
                          </PaginationNext>
                        </PaginationContainer>
                      </Pagination>
                    </HStack>
                  </HStack>
                </Box>
              )}
            </Box>
          </Container>
        </Box>
      </Box>
    </Box>
  );
}
